module.exports = __webpack_public_path__ + "static/media/banner9.cc0c2d4a.jpg";